import React, { useState } from 'react';
import { FileText, Download, Calendar } from 'lucide-react';
import toast from 'react-hot-toast';
import { generateW9PDF } from '../utils/generateW9';

const Documents: React.FC = () => {
  const [downloading, setDownloading] = useState(false);
  const currentYear = new Date().getFullYear();

  const handleDownloadW9 = async () => {
    try {
      setDownloading(true);
      const pdfBytes = await generateW9PDF();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `ITP360_W9_${currentYear}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success('W9 downloaded successfully');
    } catch (error) {
      console.error('Failed to generate W9:', error);
      toast.error('Failed to download W9. Please try again.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div>
      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Documents</h1>
        <p className="mt-1 text-sm text-gray-500">
          Download company documents
        </p>
      </div>

      {/* Documents Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* W9 Card */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center">
              <div className="flex-shrink-0 p-3 bg-blue-100 rounded-lg">
                <FileText className="h-6 w-6 text-blue-600" />
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-semibold text-gray-900">W-9 Tax Form</h3>
                <p className="text-sm text-gray-500">ITP 360 LLC</p>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-600 mb-4">
            Request for Taxpayer Identification Number and Certification. Automatically generated with current date and signature.
          </p>

          <div className="flex items-center gap-2 mb-5">
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
              <Calendar className="h-3 w-3" />
              {currentYear}
            </span>
            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
              PDF
            </span>
          </div>

          <button
            onClick={handleDownloadW9}
            disabled={downloading}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {downloading ? (
              <>
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                Generating...
              </>
            ) : (
              <>
                <Download className="h-4 w-4" />
                Download W-9
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Documents;
